import { render, staticRenderFns } from "./BuddiesModal.vue?vue&type=template&id=44a17737"
import script from "./BuddiesModal.vue?vue&type=script&lang=js"
export * from "./BuddiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports